import styled, { css } from "styled-components";
import InputMask from "react-input-mask";

export const Input = styled(InputMask)`
  ${({ theme }) => css`
    padding-left: 1rem;
    height: 3.8rem;
    width: 100%;
    border: 1px solid ${theme.colors.graySecondary};
    border-radius: 5px;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    fontfamily: "Roboto";
  `}
`;

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    bottom: 5px;
    right: 3rem;
    width: 1rem;
  `}
`;
